<template>
    <div class="product-sampling-info bg-fafafa">
        <div class="container-fluid p-container lg">
            <div class="p-l-40 d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between p-y-80 p-y-small-48 p-x-small-24">
                <div class="flex-shrink-0 position-relative m-r-40 m-r-small-0">
                    <img :src="$image(starImage)" :alt="starAlt" class="position-absolute custom-position">
                    <span class="font Roboto f-s-32 f-s-small-24 f-w-700" v-html="title" />
                </div>
                <span class="font f-s-18 leading-7 f-s-small-16 l-h-small-24 font-normal m-t-small-16" :style="{ maxWidth: maxWidth }">
                    {{ description }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductSamplingInfo',
    props: {
        title: {
            type: String,
            default: 'What is<br>Product sampling?',
        },
        description: {
            type: String,
            default: 'Product sampling is a marketing strategy that allows consumers to try a product before purchasing it. By delivering free samples directly to a targeted audience, brands can increase product awareness, gather authentic feedback, and drive trial and conversion. It\'s an effective way to build trust, generate buzz, and collect valuable insights that shape product development and marketing decisions.',
        },
        starImage: {
            type: String,
            default: 'caseStudies/usecases/StarShape.svg',
        },
        starAlt: {
            type: String,
            default: 'stars',
        },
        maxWidth: {
            type: String,
            default: '784px',
        },
    },
};
</script>

<style lang="scss" scoped>
.product-sampling-info {
    .bg-fafafa {
        background-color: #FAFAFA;
    }

    .custom-position {
        width: 43px;
        height: 41px;
        top: -29px;
        left: -10px;
        @media screen and (min-width: 768px) {
            width: 71px;
            height: 67px;
            top: -37px;
            left: -46px;
        }
    }
}

.bg-fafafa {
    background-color: #FAFAFA;
}
</style>
